import React, { useEffect, useState } from "react";

const CountTimer = ({ callTime, timeElapsedCallback }) => {
    const [timeElapsed, setTimeElapsed] = useState(callTime);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeElapsed((prev) => {
                timeElapsedCallback(prev + 1);
                return prev + 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatTime = (seconds) => {
        const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
        const secs = String(seconds % 60).padStart(2, "0");
        return `${mins} min ${secs} sec`;
    };

    return (
        <div
            style={{
                fontFamily: "monospace",
                display: "inline-block",
                position: "relative",
                textAlign: "center",
            }}
        >
            <span
                style={{
                    visibility: "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0,
                }}
            >
                00 min 00 sec
            </span>
            <span>{formatTime(timeElapsed)}</span>
        </div>
    );
};

export default CountTimer;
